import { SimpleGrid } from '@chakra-ui/react';
import * as React from 'react';

import { ImageUploadPreviewItem } from './components/ImageUploadPreviewItem';

export const ImageUploadPreview: React.FC<{
  onClick?: (value: { imageId: string } | { videoId: string }) => void;
  resourcesSyncedWithDraft: (
    | {
        imageId: string;
        url?: string;
      }
    | {
        videoId: string;
        url?: string;
      }
  )[];
}> = (props) => {
  return !!props.resourcesSyncedWithDraft?.length ? (
    <SimpleGrid mt="2" columns={[3, 5]} spacing="2">
      {props.resourcesSyncedWithDraft.map((resource) => {
        return (
          <ImageUploadPreviewItem
            key={'imageId' in resource ? resource.imageId : resource.videoId}
            resource={resource}
            url={resource.url}
            onClick={() => {
              if (props.onClick) {
                if ('imageId' in resource) {
                  props.onClick({ imageId: resource?.imageId });
                } else {
                  props.onClick({ videoId: resource?.videoId });
                }
              }
            }}
          />
        );
      })}
    </SimpleGrid>
  ) : null;
};
